import { getVenueDates } from '@/domain/project-venue-dates/actions/get-venue-dates.action.ts';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getImpactCalculateVenueCo2ForProject } from './get-impact-calculate-venue-co2-for-project.action';

type Params = {
  projectId: number;
  dateId: number;
};

type Result = void;

export const runImpactCalculateVenueEssForDate = createAppAsyncThunk(
  'impactCalculateVenue/runImpactCalculateVenueEssForDate',
  async (
    { projectId, dateId }: Params,
    { extra: { impactCalculateVenueGateway, snackbarGateway }, dispatch },
  ): Promise<Result> => {
    try {
      const modelEssVersion = 'ESS_SEASON_EVENT';
      await impactCalculateVenueGateway.runImpactCalculateVenueEssForDate(
        dateId,
        projectId,
        modelEssVersion,
      );
      dispatch(getImpactCalculateVenueCo2ForProject({ projectId }));
      await dispatch(getVenueDates());
      setTimeout(
        () => dispatch(getImpactCalculateVenueCo2ForProject({ projectId })),
        2000,
      );
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
